import { render, staticRenderFns } from "./UserCommisions.vue?vue&type=template&id=e03eb5b0&scoped=true&"
import script from "./UserCommisions.vue?vue&type=script&lang=js&"
export * from "./UserCommisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03eb5b0",
  null
  
)

export default component.exports